import { API_STATES } from "@/helpers";

const state = {
  companiesGetState                  : API_STATES.NOT_REQUESTED,
  companiesGetError                  : null,
  companyUpdateState                 : API_STATES.NOT_REQUESTED,
  companyUpdateError                 : null,
  companyDeleteState                 : API_STATES.NOT_REQUESTED,
  companyDeleteError                 : null,
  createOnBoardingThirdStepDataState : API_STATES.NOT_REQUESTED,
  createOnBoardingThirdStepDataError : null,
  getOnboardingThirdStepDataState    : API_STATES.NOT_REQUESTED,
  getOnboardingThirdStepDataError    : null,
  companies                          : [],
  companiesCount                     : 0,
  onboardingThirdStepData            : {
    positions : [],
    stores    : [],
    employees : []
  }
};

export default state;